import script from "./BaseView.vue?vue&type=script&lang=ts&setup=true"
export * from "./BaseView.vue?vue&type=script&lang=ts&setup=true"

import "./BaseView.vue?vue&type=style&index=0&id=e9c1efea&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e9c1efea"]])

export default __exports__